module.exports = __webpack_public_path__ + "static/img/greenCircle.0dec2890.svg";